/**
 * @description Generate a url to add an event to Google Calendar.
 */
export function googleCalendarUrl(
  title: string,
  details: string,
  location: string,
  startDate: Date,
  endDate: Date
): string {
  const url = new URL('https://www.google.com/calendar/render');

  url.searchParams.append('action', 'TEMPLATE');
  url.searchParams.append('text', title);
  url.searchParams.append('details', details);
  url.searchParams.append('location', location);
  url.searchParams.append('dates', `${format(startDate)}/${format(endDate)}`);

  return url.toString();
}

/**
 * @description Generate a url to add an event to Outlook Calendar
 */
export function outlookUrl(
  title: string,
  description: string,
  location: string,
  startDate: Date,
  endDate: Date
): string {
  const url = new URL('https://outlook.live.com/owa/');

  url.searchParams.append('path', '/calendar/action/compose');
  url.searchParams.append('rru', 'addevent');
  url.searchParams.append('startdt', format(startDate));
  url.searchParams.append('enddt', format(endDate));
  url.searchParams.append('subject', title);
  url.searchParams.append('body', description);
  url.searchParams.append('location', location);

  return url.toString();
}

/**
 * @description generate iCalendar url
 */
export function icsUrl(
  title: string,
  description: string,
  location: string,
  startDate: Date,
  endDate: Date
): string {
  return encodeURI(
    'data:text/calendar;charset=utf8,' +
      [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'BEGIN:VEVENT',
        'URL:' + document.URL,
        'DTSTART:' + format(startDate),
        'DTEND:' + format(endDate),
        'SUMMARY:' + title,
        'DESCRIPTION:' + description,
        'LOCATION:' + location,
        'END:VEVENT',
        'END:VCALENDAR',
      ].join('\n')
  );
}

/**
 * @description Format to ISO string compliant with GCal and Outlook
 */
function format(date: Date): string {
  // Remove the `:`, `-` and the milliseconds for Google Calendar
  return date
    .toISOString()
    .replace(/:/g, '')
    .replace(/-/g, '')
    .replace(/\..../g, ''); // remove ms
}
